import { createTransform } from 'redux-persist';

// LOGIC: remove the privateKey, publicKey, and pKey_parts.privateKey from the persist only if the user is not an admin

export const excludePrivateKeyTransform = createTransform(
    (inboundState: any) => {
        // it will return for activeServer and serverData changes one of them is string the other is object
        // if the object changed -> the serverData -> in this case check if the user is admin or not and persist the pKeys accordingly

        if (typeof inboundState === 'object') {
            let sanitizedState = { ...inboundState };

            if (sanitizedState) {
                let serverData = sanitizedState;

                if (typeof serverData === 'string') {
                    try {
                        serverData = JSON.parse(serverData);
                    } catch (e) {
                        return sanitizedState;
                    }
                }
                const cleanedServerData = { ...serverData };

                Object.keys(cleanedServerData).forEach(serverId => {
                    const server = cleanedServerData[serverId];

                    if (!server?.isAdminChecked) {
                        if (server?.privateKey) {
                            // Remove the privateKey
                            const { publicKey, privateKey, ...rest } = server;
                            cleanedServerData[serverId] = {
                                ...rest,
                            };
                        }
                        if (server?.pkey_parts?.privateKey) {
                            // Remove the privateKey inside pkey_parts
                            const { privateKey, ...restPkeyParts } =
                                server.pkey_parts;

                            cleanedServerData[serverId] = {
                                ...server,
                                pkey_parts: restPkeyParts,
                            };
                        }
                    }
                });

                // Convert back to string if it was originally a string
                sanitizedState =
                    typeof sanitizedState === 'string'
                        ? JSON.stringify(cleanedServerData)
                        : cleanedServerData;
            }
            return sanitizedState;
        }
        return inboundState;
    },
    (outboundState: any) => outboundState,
);
